import { AxiosResponse } from 'axios'

import {
  Brand,
  LookProductApiResponse,
  NoticesCollection,
  NoticesLoading,
  SetDeleteLoadingAction,
  UILocalizations,
  MergeProductsAction,
  InitiateAProductRemovalAction,
  CancelAProductRemovalAction,
} from '../types/products'
import {
  BatchLookupValue,
  LookupValues,
  Mode,
  NoticeToMarkReviewed,
  NoticeToMarkReviewedLoading,
  SearchFunc,
} from '../types/ui'
import { ApiLocalization, BrandSearchMode } from '../../types'

export const GET_PRODUCTS = '[command] products/GET_PRODUCTS'
export const POPULATE_BATCH_PRODUCTS = '[command] products/POPULATE_BATCH_PRODUCTS'
export const GET_A_PRODUCT = '[command] products/GET_A_PRODUCT'
export const POST_A_PRODUCT = '[command] products/POST_A_PRODUCT'
export const INITIATE_A_PRODUCT_REMOVAL = '[command] products/INITIATE_A_PRODUCT_REMOVAL'
export const CANCEL_A_PRODUCT_REMOVAL = '[command] products/CANCEL_A_PRODUCT_REMOVAL'
export const GET_BRANDS = '[command] products/GET_BRANDS'
export const CREATE_BRAND = '[command] products/CREATE_BRAND'
export const GET_PHOTOS = '[command] products/GET_PHOTOS'
export const GET_NOTICES = '[command] products/GET_NOTICES'
export const MARK_NOTICES_REVIEWED = '[command] products/MARK_NOTICES_REVIEWED'
export const CREATE_NOTICE = '[command] products/CREATE_NOTICE'
export const MERGE_PRODUCTS = '[command] products/MERGE_PRODUCTS'
export const CREATE_BRAND_SUCCESS = '[event] products/CREATE_BRAND_SUCCESS'
export const CREATE_BRAND_ERROR = '[event] products/CREATE_BRAND_ERROR'
export const CREATE_NOTICE_SUCCESS = '[event] products/CREATE_NOTICE_SUCCESS'
export const CREATE_NOTICE_ERROR = '[event] products/CREATE_NOTICE_ERROR'
export const GET_BRANDS_SUCCESS = '[event] products/GET_BRANDS_SUCCESS'
export const GET_BRANDS_ERROR = '[event] products/GET_BRANDS_ERROR'
export const GET_PRODUCTS_SUCCESS = '[event] products/GET_PRODUCTS_SUCCESS'
export const GET_PRODUCTS_ERROR = '[event] products/GET_PRODUCTS_ERROR'
export const GET_NOTICES_SUCCESS = '[event] products/GET_NOTICES_SUCCESS'
export const GET_NOTICES_ERROR = '[event] products/GET_NOTICES_ERROR'
export const GET_LOCALIZATIONS = '[event] product/GET_LOCALIZATIONS'
export const GET_LOCALIZATIONS_SUCCESS = '[event] product/GET_LOCALIZATIONS_SUCCESS'
export const GET_LOCALIZATIONS_ERROR = '[event] product/GET_LOCALIZATIONS_ERROR'
export const SAVE_LOCALIZATIONS = '[event] product/SAVE_LOCALIZATIONS'
export const SAVE_LOCALIZATION_SUCCESS = '[event] product/SAVE_LOCALIZATION_SUCCESS'
export const SAVE_LOCALIZATION_ERROR = '[event] product/SAVE_LOCALIZATION_ERROR'
export const SET_LOCALIZATION_STATUS = '[event] product/SET_LOCALIZATION_STATUS'
export const MARK_NOTICES_REVIEWED_SUCCESS = '[event] products/MARK_NOTICES_REVIEWED_SUCCESS'
export const MARK_NOTICES_REVIEWED_ERROR = '[event] products/MARK_NOTICES_REVIEWED_ERROR'
export const MERGE_PRODUCTS_SUCCESS = '[event] products/MERGE_PRODUCTS_SUCCESS'
export const MERGE_PRODUCTS_ERROR = '[event] products/MERGE_PRODUCTS_ERROR'
export const GET_A_PRODUCT_SUCCESS = '[event] products/GET_A_PRODUCT_SUCCESS'
export const GET_A_PRODUCT_ERROR = '[event] products/GET_A_PRODUCT_ERROR'
export const POST_A_PRODUCT_SUCCESS = '[event] products/POST_A_PRODUCT_SUCCESS'
export const POST_A_PRODUCT_ERROR = '[event] products/POST_A_PRODUCT_ERROR'
export const INITIATE_A_PRODUCT_REMOVAL_SUCCESS =
  '[event] products/INITIATE_A_PRODUCT_REMOVAL_SUCCESS'
export const INITIATE_A_PRODUCT_REMOVAL_ERROR = '[event] products/INITIATE_A_PRODUCT_REMOVAL_ERROR'
export const CANCEL_A_PRODUCT_REMOVAL_SUCCESS = '[event] products/CANCEL_A_PRODUCT_REMOVAL_SUCCESS'
export const CANCEL_A_PRODUCT_REMOVAL_ERROR = '[event] products/CANCEL_A_PRODUCT_REMOVAL_ERROR'
export const GET_PHOTOS_SUCCESS = '[event] products/GET_PHOTOS_SUCCESS'
export const GET_PHOTOS_ERROR = '[event] products/GET_PHOTOS_ERROR'
export const SET_PRODUCTS = '[document] products/SET_PRODUCTS'
export const SET_BATCH_PRODUCTS = '[document] products/SET_BATCH_PRODUCTS'
export const SET_PHOTOS = '[document] products/SET_PHOTOS'
export const SET_BATCH_PHOTOS = '[document] products/SET_BATCH_PHOTOS'
export const SET_NOTICES = '[document] products/SET_NOTICES'
export const SET_LOCALIZATIONS = '[document] products/SET_LOCALIZATIONS'
export const SET_NOTICES_REVIEWED_STATUS = '[document] products/SET_NOTICES_REVIEWED_STATUS'
export const SET_MARK_REVIEWED_LOADING = '[document] products/SET_MARK_REVIEWED_LOADING'
export const SET_MERGE_PRODUCTS_LOADING = '[document] products/MERGE_PRODUCTS_LOADING'
export const SET_DELETE_LOADING = '[document] products/SET_DELETE_LOADING'
export const SET_BRANDS = '[document] products/SET_BRANDS'
export const ADD_BRAND = '[document] products/ADD_BRAND'
export const CLEAR_NEW_BRAND = '[document] products/CLEAR_NEW_BRAND'
export const SET_BRAND_SEARCH_MODE = '[document] products/SET_BRAND_SEARCH_MODE'

// Commands

export const saveLocalizations = (payload: {
  localizations: UILocalizations
  productId: string
  productUuid: string
}) => ({
  type: SAVE_LOCALIZATIONS,
  payload,
})

export const setLocalizationStatus = (payload: {
  newProductLocalizationId?: string
  originalLocalizationId?: string
  country: string
  subdivision: string
  updated: Date
  success: boolean
  failure: boolean
}) => ({
  type: SET_LOCALIZATION_STATUS,
  payload,
})

export const getLocalizations = (payload: { productId: string }) => ({
  type: GET_LOCALIZATIONS,
  payload,
})

export const setLocalizations = (payload: {
  productUuid: string
  productId: string
  localizations: ApiLocalization[]
}) => {
  return {
    type: SET_LOCALIZATIONS,
    payload,
  }
}
export const getNotices = () => ({
  type: GET_NOTICES,
  payload: {},
})

export const getBrands = () => ({
  type: GET_BRANDS,
  payload: {},
})

export const setBrandSearchMode = (payload: { mode: BrandSearchMode }) => ({
  type: SET_BRAND_SEARCH_MODE,
  payload,
})

export const createNotice = (payload: {
  notice: {
    product_id: string | number
    kind: string
    data: object | null
  }
}) => ({
  type: CREATE_NOTICE,
  payload,
})

export const getProducts = (payload: {
  values: LookupValues | BatchLookupValue
  searchFunc: SearchFunc
  batchId?: string
  brandSearchMode?: BrandSearchMode
  isBatchLookupMode?: boolean
  enableDeepMatcher?: boolean
}) => ({
  type: GET_PRODUCTS,
  payload,
})

export const markNoticesReviewed = (payload: { notices: NoticeToMarkReviewed[] }) => ({
  type: MARK_NOTICES_REVIEWED,
  payload,
})

export const createBrand = (payload: { name: string }) => ({
  type: CREATE_BRAND,
  payload,
})

export const mergeProducts = (payload: MergeProductsAction['payload']) => ({
  type: MERGE_PRODUCTS,
  payload,
})

export const populateBatchProducts = (payload: { batchId: string }) => ({
  type: POPULATE_BATCH_PRODUCTS,
  payload,
})

export const getAProduct = (payload: {
  productId: number
  mode: Mode
  alias?: string
  isBatchLookup?: boolean
}) => ({
  type: GET_A_PRODUCT,
  payload,
})

export const postAProduct = (payload: {
  formData: FormData
  mode: Mode
  isBatchLookup: boolean
  isBulkEdit?: boolean
  batchCreationIndex?: number
}) => ({
  type: POST_A_PRODUCT,
  payload,
})

/**
 * Action to initiate a Product Removal.
 * If you need to mark a notice as reviewed, you must provide
 * a `notice` parameter.
 */
export const initiateAProductRemoval = (payload: InitiateAProductRemovalAction['payload']) => ({
  type: INITIATE_A_PRODUCT_REMOVAL,
  payload,
})

export const cancelAProductRemoval = (payload: CancelAProductRemovalAction['payload']) => ({
  type: CANCEL_A_PRODUCT_REMOVAL,
  payload,
})

export const getPhotos = (payload: { productIds: string[]; batchId?: string }) => ({
  type: GET_PHOTOS,
  payload,
})

// Documents
export const setProducts = (
  payload: {
    products: LookProductApiResponse[]
    batchId?: string
  } | null
) => ({
  type: SET_PRODUCTS,
  payload,
})

export const setBrands = (payload: { brands: Brand[] }) => ({
  type: SET_BRANDS,
  payload,
})

export const addBrand = (payload: { brand: Brand }) => ({
  type: ADD_BRAND,
  payload,
})

export const clearNewBrand = () => {
  return {
    type: CLEAR_NEW_BRAND,
  }
}

// Documents
export const setNotices = (payload: {
  notices: NoticesCollection
  productIdToUuid: Record<number, string>
  noticesLoading: NoticesLoading
}) => {
  return {
    type: SET_NOTICES,
    payload,
  }
}

export const setMarkedReviewedLoading = (payload: { notices: NoticeToMarkReviewedLoading[] }) => {
  return {
    type: SET_MARK_REVIEWED_LOADING,
    payload,
  }
}

export const setMergeProductsLoading = (payload: { product_uuid: string; loading: boolean }) => {
  return {
    type: SET_MERGE_PRODUCTS_LOADING,
    payload,
  }
}

export const setDeleteLoading = (payload: SetDeleteLoadingAction['payload']) => {
  return {
    type: SET_DELETE_LOADING,
    payload,
  }
}

export const setNoticesReviewedStatus = (payload: { notices: NoticeToMarkReviewed[] }) => {
  return {
    type: SET_NOTICES_REVIEWED_STATUS,
    payload,
  }
}

export const setBatchProducts = (
  payload: {
    products: LookProductApiResponse[]
    batchId: string
  } | null
) => ({
  type: SET_BATCH_PRODUCTS,
  payload,
})

export const setPhotos = (
  payload: {
    productPhotosResponse: AxiosResponse[]
    batchId?: string
  } | null
) => ({
  type: SET_PHOTOS,
  payload,
})

export const setBatchPhotos = (
  payload: {
    productPhotosResponse: AxiosResponse[]
    batchId: string
  } | null
) => ({
  type: SET_BATCH_PHOTOS,
  payload,
})
